import { render, staticRenderFns } from "./EntrepreneurshipTasksModule.vue?vue&type=template&id=0b6cb19d"
import script from "./EntrepreneurshipTasksModule.vue?vue&type=script&lang=js"
export * from "./EntrepreneurshipTasksModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports